import { SortOrder } from "../sort-order";

export class DefaultDeviceCatalogFilters {
  name: string;
  version: string;
  active: boolean;
  defaultDeviceCategoryNames: string[];
  defaultAssetRepresentationNames: string[];
  creationRangeDates: number[];
  updateRangeDates: number[];
  sortField: string;
  sortOrder: SortOrder;
}
